/**
 * Component with containing div, label, and input - to avoid repeated code in PoiDialog and PoiGroupDialog
 */
export const PoiDialogInput = ({
    label,
    value,
    onChange,
    onBlur,
    disabled,
    intersection = false, //intersection section of PoiDialog as different styling
    boldLabel = true,
    placeholder = null,
    className
}) => {
    const formattedValue = typeof value === 'number' ? value.toFixed(5) : value;
    
    return(
        <div className={`mb-1 flex items-center ${intersection ? 'justify-around' : 'justify-between'} `}>
            <label
                className={`${intersection || boldLabel === false ? null : 'font-bold'}`}
                htmlFor={label.replace(/\s+/g, '-')}
            >
                {label}:
            </label>

            <input
                id={label.replace(/\s+/g, '-')}
                className={`border border-black rounded ml-5 text-center ${className}`}
                type="text"
                value={formattedValue}
                onChange={onChange || null}
                onBlur={onBlur || null}
                readOnly={!onChange}
                disabled={disabled}
                placeholder={placeholder}
              />

        </div>

    )
}